<template>
  <CalendarFilterButton
    :label="label"
    :disabled="disabled"
    :icon="icon"
    size="lg"
    :label-i18n="labelI18n"
    class="relative max-lg:mb-8"
  >
    <template #icon>
      <i-rotate-right-one />
    </template>

    <template #below-label>
      <div class="w-full text-left max-lg:pb-4">
        <span class="text-blue-800 font-semibold">
          {{ internalValue.min }} - {{ internalValue.max ? internalValue.max : MAX_DAYS + '+' }}
        </span>

        <div class=" max-lg:absolute max-lg:top-full max-lg:left-0 w-full">
          <div class="px-2 mt-4 w-full">
            <RangeSlider
              class="w-full"
              :min="MIN_DAYS"
              :max="MAX_DAYS + 1"
              :tooltip="false"
              :step-pointer-margin="1"
              :value="[value.min, value.max]"
              @input="handleChange"
              @move="handleMove"
            />
          </div>

          <div class="flex justify-between mt-1 font-secondary max-lg:font-semibold">
            <span>
              {{ MIN_DAYS }}
              <span class="md:hidden">
                dag
              </span>
            </span>
            <span>
              {{ MAX_DAYS }}+ {{ $t ('label.days') }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </CalendarFilterButton>
</template>

<script setup lang="ts">
const MIN_DAYS = 1
const MAX_DAYS = 20

const props = withDefaults(
  defineProps<{
    label: string
    value: {
      min: number
      max: number
    }
    placeholder: string
    icon: string | object
    isActive: boolean
    labelI18n?: string | null
    disabled?: boolean
  }>(),
  {
    labelI18n: null,
    disabled: false,
  }
)

const emit = defineEmits(['change'])

const internalValue = ref({})

const handleChange = ([min, max]: [number, number]) => {
  emit(
    'change',
    min,
    max > MAX_DAYS
      ? null // MAX_DAYS+
      : max
  )
}

onMounted(() => {
  internalValue.value = { ...props.value }
})

const handleMove = (stepValue) => {
  internalValue.value = {
    min: stepValue[0],
    max: stepValue[1],
  }
}
</script>
